'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('../../polyfills/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectGetPrototypeOf = require('../../polyfills/objectGetPrototypeOf');

var _objectGetPrototypeOf2 = _interopRequireDefault(_objectGetPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('../../polyfills/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('../../polyfills/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('../../polyfills/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _all = require('../../../data/all.json');

var _all2 = _interopRequireDefault(_all);

var _nimblePicker = require('./nimble-picker');

var _nimblePicker2 = _interopRequireDefault(_nimblePicker);

var _sharedProps = require('../../utils/shared-props');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Picker = function (_React$PureComponent) {
  (0, _inherits3.default)(Picker, _React$PureComponent);

  function Picker() {
    (0, _classCallCheck3.default)(this, Picker);
    return (0, _possibleConstructorReturn3.default)(this, (Picker.__proto__ || (0, _objectGetPrototypeOf2.default)(Picker)).apply(this, arguments));
  }

  (0, _createClass3.default)(Picker, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_nimblePicker2.default, (0, _extends3.default)({}, this.props, this.state));
    }
  }]);
  return Picker;
}(_react2.default.PureComponent);

exports.default = Picker;

Picker.defaultProps = (0, _extends3.default)({}, _sharedProps.PickerDefaultProps, { data: _all2.default });


/*****************
 ** WEBPACK FOOTER
 ** ../~/emoji-mart/dist/components/picker/picker.js
 ** module id = 1629
 ** module chunks = 3
 **/